import React, { useCallback, useEffect, useState } from 'react';

import { useListIrregularProducts } from 'v2/hooks/products/useListIrregularProducts';

import ProductTable from '../ProductTable';
import QuickView from './components/Quickview';

interface IProps {
  search: string;
}

const INITIAL_PAGINATION = { current_page: 1, per_page: 10 };
const DEFAULT_OPTIONS_PER_PAGE = '10,20,30,40';

const Irregular = ({ search }: IProps) => {
  const [activeQuickView, setActiveQuickView] = useState(false);
  const [dataProduct, setDataProduct] = useState<any>(null);
  const [paginationParams, setPaginationParams] = useState(INITIAL_PAGINATION);

  const { data, pagination, isFetching } = useListIrregularProducts(paginationParams, search);

  useEffect(() => {
    setPaginationParams(prev => ({ ...prev, current_page: 1 }));
  }, [search]);

  const onChangeRowsPerPage = useCallback((perPage: number) => {
    setPaginationParams(prev => ({ ...prev, current_page: 1, per_page: perPage }));
  }, []);

  const onChangePage = useCallback((page: number) => {
    setPaginationParams(prev => ({ ...prev, current_page: page }));
  }, []);

  const onClickOptions = useCallback((product: any) => {
    setActiveQuickView(true);
    setDataProduct(product);
  }, []);

  const toggleQuickView = useCallback(() => {
    setActiveQuickView(prev => !prev);
  }, []);

  return (
    <>
      <ProductTable
        products={data}
        order=''
        onClickOptions={onClickOptions}
        coproduction={false}
        irregular={true}
        isLoading={isFetching}
        pagination={{
          current_page: pagination?.current_page ?? INITIAL_PAGINATION.current_page,
          per_page: pagination?.per_page ?? INITIAL_PAGINATION.per_page,
          total: pagination?.total_items,
          optionsPerPage: DEFAULT_OPTIONS_PER_PAGE,
          onChangePage,
          onChangePerPage: onChangeRowsPerPage
        }}
      />

      <QuickView active={activeQuickView} changeActive={toggleQuickView} productData={dataProduct} />
    </>
  );
};

export default Irregular;
